(() => {
  class MirandaV2Tabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const bar = this.querySelector('[data-mv2-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-mv2-tab]'));
      const panels = tabs.map(tab => Array.from(this.querySelectorAll('[data-mv2-panel]')).find(panel => panel.id === tab.getAttribute('aria-controls')));
      if (!bar || tabs.length === 0 || panels.some(panel => !panel)) return;
      this.initialized = true;
      bar.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); this.select(index); });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); this.select(index); return; }
          else return;
          event.preventDefault();
          this.select(next);
          tabs[next].focus();
        });
      });
      this.select = index => {
        tabs.forEach((tab, position) => { tab.setAttribute('aria-selected', String(position === index)); tab.tabIndex = position === index ? 0 : -1; panels[position].hidden = position !== index; });
        this.activePanel = panels[index];
      };
      this.select(0);
      this.editorSelect = event => {
        const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index !== -1) this.select(index);
      };
      this.addEventListener('shopify:block:select', this.editorSelect);
    }
  }
  class MirandaV2BuyHelper extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.target = document.querySelector('.product__info-container .product-form__buttons') || document.querySelector('.product-form__buttons');
      const button = this.querySelector('button');
      if (!this.target || !button || !('IntersectionObserver' in window)) return;
      this.returnToOptions = () => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const info = document.querySelector('.miranda-product .product__info-container') || this.target;
        const header = document.querySelector('.section-header');
        const headerHeight = header ? Math.max(0, header.getBoundingClientRect().height) : 0;
        const top = Math.max(0, window.scrollY + info.getBoundingClientRect().top - headerHeight - 20);
        window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
        const control = info.querySelector('variant-selects select, variant-selects input:checked, .product-form__input select, .product-form__buttons button');
        if (control) control.focus({ preventScroll: true });
      };
      button.addEventListener('click', this.returnToOptions);
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.hidden = !show;
        document.body.classList.toggle('mv2-buy-helper-active', show);
      }, { threshold: 0 });
      this.observer.observe(this.target);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('button')?.removeEventListener('click', this.returnToOptions);
      document.body.classList.remove('mv2-buy-helper-active');
    }
  }
  if (!customElements.get('miranda-v2-tabs')) customElements.define('miranda-v2-tabs', MirandaV2Tabs);
  if (!customElements.get('miranda-v2-buy-helper')) customElements.define('miranda-v2-buy-helper', MirandaV2BuyHelper);
  const initializeHeader = () => {
    [['.header_burger', '.mobile-category-menu'], ['#search-icon', '.search-wrapper']].forEach(([buttonSelector, panelSelector]) => {
      const button = document.querySelector('.miranda-v2 ' + buttonSelector);
      const panel = document.querySelector('.miranda-v2 ' + panelSelector);
      if (!button || !panel || button.dataset.mv2AriaBound) return;
      button.dataset.mv2AriaBound = 'true';
      const update = () => button.setAttribute('aria-expanded', String(panel.classList.contains('open')));
      new MutationObserver(update).observe(panel, { attributes: true, attributeFilter: ['class'] });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeHeader, { once: true });
  else initializeHeader();
  document.addEventListener('shopify:section:load', initializeHeader);
})();
